import { type Common } from './common.js';
import { type FindAllOptions, type Log, type LogBase } from './models/log.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options?: FindAllOptions): Promise<Log[]> {
    const url = this.common.constructPath('/log', options);
    const { logs } = await this.common.getJSON(url);
    return logs;
  }

  async create(log: LogBase): Promise<Log> {
    const url = this.common.constructPath('/log');
    return await this.common.postJSON(url, log);
  }
}
